import React, { useEffect, useMemo } from 'react'
import { observer } from 'mobx-react'
import { cartMobx, deskMobx, restaurantConfig } from 'restaurant'
import { storeMobx, deliveryMobx } from '@mobxStore'
import { confirmLayer, modalLayer, showMsg, useHistoryNew } from '@utils'
import { Icon, SelectAddressModal } from '@cps'
import { TCodeType } from 'restaurant/mobx/center/restaurantCenter'
import { TEEatType } from 'restaurant/mobx/store.mobx'
import DeliveryController from '@ctrls/deliveryController'
import './index.scss'

const StoreBar: React.FC = () => {
  const history = useHistoryNew()
  const isBuyTogether = !!Config.buyTogetherId
  const { address, viewAddresses } = deliveryMobx
  const { info: store } = storeMobx
  const eatType = cartMobx.info.eatType
  /** 外卖并且不是拼单 */
  const showDelivery = restaurantConfig.codeType === TCodeType.Brand && eatType === TEEatType.delivery && !isBuyTogether
  const goToStore = () => {
    // 不存在购物车订单才可以切换门店
    if (cartMobx.ordersId) {
      showMsg(i18n.t('menu.disableSwitchStore'))
      return
    }
    if (restaurantConfig.codeType === TCodeType.Brand && !isBuyTogether) {
      if (eatType === TEEatType.delivery) {
        history.push('/store', null, { isDelivery: '1' })
      } else {
        history.push('/store')
      }
    }
  }
  const storeAddress = useMemo(() => {
    if (restaurantConfig.codeType === 'table') {
      return deskMobx.tableCodeToTableAliasMap[Config.TABLECODE]
    }
    return store.storeName
  }, [storeMobx.info, deskMobx.tableCodeToTableAliasMap])
  /** 选择其他地址 */
  const handleSelectAddress = async () => {
    if (viewAddresses?.length) {
      modalLayer(SelectAddressModal, {
        eatType: TEEatType.delivery
      }, 'SelectAddressModal').then(() => {
      }, () => { })
    } else {
      DeliveryController.editAddressModal({
        eatType: TEEatType.delivery,
        callback: (store) => {
          if (store) {
            confirmLayer({
              title: i18n.t('common.attention'),
              children: (
                <>
                  <div className='near-tip'>{i18n.t('newCart.matchNearStore')}</div>
                  <div className='near-store'>
                    <Icon name='dinein3' />{store?.storeName}
                  </div>
                </>
              ),
              className: 'near-store-confirm-modal',
              isLight: true,
              canClose: true,
            }).then(() => {
              storeMobx.initInfo(store)
            }, () => { })
          }
        }
      })
    }
  }

  /** 外卖展示的门店结构 */
  const StoreDelivery = () => {
    return (
      <div className='menu-store-bar-container delivery'>
        <div className='store-info' onClick={goToStore}>
          <Icon name='mendian1' />
          {!!storeAddress && (
            <div className='store-address'>
              <div className='store-name'>{storeAddress}</div>
            </div>
          )}
          <div className='arrow-icon'>
            <Icon name='jiantou' />
          </div>
        </div>
        <div className='address-wrapper' onClick={handleSelectAddress}>
          <Icon name='mubiao' />
          <span className='address-name'>
            {
              address ? (
                `${address.address}`
              ) : deliveryMobx.availableAddress && restaurantConfig.lbsAddress ? (
                restaurantConfig.lbsAddress
              ) : (
                i18n.t(!viewAddresses?.length ? 'newCart.addAddressTip' : 'newCart.selectAddress')
              )
            }
          </span>
        </div>
      </div>
    )
  }
  /** 默认展示 */
  const StoreDefault = () => {
    return (
      <div className='menu-store-bar-container default' onClick={goToStore}>
        <div className='store-info'>
          <Icon name='mubiao' />
          {!!storeAddress && (
            <div className='store-address'>
              <div className='store-name'>{storeAddress}</div>
            </div>
          )}
        </div>
      </div>
    )
  }
  return (
    showDelivery ? (
      <StoreDelivery />
    ) : (
      <StoreDefault />
    )
  )
}

export default observer(StoreBar)
